var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.headBlock && _vm.headBlock != 'N/A')?_c('v-chip',{staticStyle:{"text-transform":"capitalize","height":"36px","background-color":"white !important"},attrs:{"color":"black","outlined":"","label":""}},[_vm._v(" Head Block: "+_vm._s(_vm.headBlock)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }